export default __webpack_public_path__ + "static/media/logo-light.88f7ad70.png";